/* unplugin-vue-components disabled */import script from "./CancelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelDialog.vue?vue&type=script&setup=true&lang=js"

import "./CancelDialog.vue?vue&type=style&index=0&id=4d5b1f9e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5b1f9e"]])

export default __exports__